
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Course from "./Courses/Course";
import { useDispatch, useSelector } from "react-redux";
import classes from "./Connect.module.css";
import { participantsApi, studyGroupsApi } from "../../utils";
import { throwApiError } from "../lms-shared/store/error-handling-actions"
import { ParticipantTypeEnumText } from "../../models/ParticipantTypeEnum";
import { onKeyDown } from "../../service";

const Connect = () => {

    const { homeUrl } = useSelector(state => state.application);
    const { studyGroupId } = useParams()
    const courses = useSelector(state => state.courses.courses);
    const dispatch = useDispatch()
    const [currentCourse, setCurrentCourse] = useState()
    const texts = useSelector((state => state.translate.texts))
    // projectsApi.projectsFilterIdPost(projectId, (error, resProjectData, response) => {
    const navigate = useNavigate()

    useEffect(() => {
        studyGroupsApi.studyGroupsFilterIdPost(studyGroupId, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.studyGroupsFilterError, error: error, statusCode: response?.statusCode, message: "studyGroupsFilterRangePost " + error.message, level: 1, component: "course-actions", line: 28 }))
            }
            else {
                setCurrentCourse(resdata)
            }
        })
    }, [courses])

    const JoinStudyGroup = async () => {
        let data = {
            participantType: ParticipantTypeEnumText.teacher,
            studyGroupId: studyGroupId,
            userExternalId: null
        }
        participantsApi.participantsAddPost({ participantInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.participantsAddError, error: error, statusCode: response?.statusCode, message: "participantsAddPost " + error.message, level: 2, component: "CurriculumPage", line: 36 }))
            }
            else {
                navigate(`${homeUrl}/courses`)
            }
        })
    }


    return (
        <>
            {currentCourse && < div className={classes.ConnectWarrper}>
                <div>
                    <div className={classes.TeacherInviteText}> {currentCourse.teacherFullName} {texts.inviteTeacher} </div>
                    <div className={classes.CourseWarrper}>
                        <Course pendingSubmissionsCount={null} isProfession={true} pendingMessagesCount={null} name={currentCourse.name} courseName={currentCourse.course.name}>  </Course>
                        <div className={classes.JoinBtn} onClick={JoinStudyGroup} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, JoinStudyGroup)}> {texts.join}</div>
                    </div>
                </div>
            </div>}
        </>
    )

}
export default Connect